import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface CacheListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class CacheListPage extends Component<CacheListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.cache(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}